import ProjectCreate from './components/project/create/ProjectCreate';
import ProjectEdit from './components/project/edit/ProjectEdit';
import ProjectEditUsers from './components/project/edit/ProjectEditUsers';
import Users from './components/users/Users';
import Firms from './components/firms/Firms';
import Project from './components/project/Project';
import Projects from './components/projects/Projects';
import { MainLayout } from './components/layouts/MainLayout';
import ChangePassword from './components/users/changePassword/ChangePassword';
import ManageUser from './components/users/externalUsers/SetTemPassword';
import CreateUser from './components/users/externalUsers/CreateUser';
import CreateFirm from './components/firms/externalFirms/CreateFirm';
import EditFirm from './components/firms/externalFirms/EditFirm';
import Reports from './components/reports/Reports';

const createProjectRoute = {
  component: ProjectCreate,
  url: '/projects/create',
};
const editProjectRoute = {
  component: ProjectEdit,
  url: '/projects/:projectId/details/edit',
};
const editProjectUserRoute = {
  component: ProjectEditUsers,
  url: '/projects/:projectId/users/edit',
};
const viewUsersRoute = {
  component: Users,
  url: '/users',
  layout: MainLayout,
};
const viewFirmsRoute = {
  component: Firms,
  url: '/firms',
  layout: MainLayout,
};
const viewProjectsRoute = {
  component: Projects,
  url: '/projects',
  layout: MainLayout,
};
const viewProjectDetailRoute = {
  component: Project,
  url: '/projects/:projectId',
  layout: MainLayout,
};
const viewProjectCategoryRoute = {
  component: Project,
  url: '/projects/:projectId/documents/categories/:documentsCategoryId',
  layout: MainLayout,
};
const changePasswordRoute = {
  component: ChangePassword,
  url: '/changePassword',
  layout: MainLayout,
};
const manageUserRoute = {
  component: ManageUser,
  url: '/users/manage',
};
const createUserRoute = {
  component: CreateUser,
  url: '/users/create',
};
const createFirmRoute = {
  component: CreateFirm,
  url: '/firms/create',
};
const editFirmRoute = {
  component: EditFirm,
  url: '/firms/:externalCompanyId/edit',
};
const viewReportsRoute = {
  component: Reports,
  url: '/reports',
  layout: MainLayout,
};
export {
  createProjectRoute,
  editProjectRoute,
  editProjectUserRoute,
  viewUsersRoute,
  viewProjectsRoute,
  viewProjectDetailRoute,
  viewProjectCategoryRoute,
  changePasswordRoute,
  manageUserRoute,
  createUserRoute,
  viewFirmsRoute,
  createFirmRoute,
  editFirmRoute,
  viewReportsRoute,
};
